import * as tslib_1 from "tslib";
import * as Dot from 'dot-object';
import merge from 'deepmerge';
import { objToFormData } from '../utils/obj-to-form-data';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var Settings = /** @class */ (function () {
    function Settings() {
        this.config$ = new BehaviorSubject({});
    }
    Settings.prototype.setMultiple = function (settings) {
        if (!settings)
            return;
        var newConfig = tslib_1.__assign({}, this.config$.value);
        Object.entries(settings).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value === '0' || value === '1') {
                value = parseInt(value);
            }
            Dot.set(key, value, newConfig);
        });
        this.config$.next(newConfig);
    };
    Settings.prototype.merge = function (config) {
        this.config$.next(merge(this.config$.value, config));
    };
    Settings.prototype.set = function (name, value) {
        var newConfig = tslib_1.__assign({}, this.config$.value);
        Dot.set(name, value, newConfig);
        this.config$.next(newConfig);
    };
    Settings.prototype.get = function (name, defaultValue) {
        if (defaultValue === void 0) { defaultValue = null; }
        var value = Dot.pick(name, this.config$.value);
        if (value == null) {
            return defaultValue;
        }
        else {
            return value;
        }
    };
    Settings.prototype.getFlat = function (name) {
        return Dot.dot(name ? this.config$.value[name] : this.config$.value);
    };
    Settings.prototype.all$ = function () {
        return this.config$.asObservable();
    };
    Settings.prototype.has = function (name) {
        return !!Dot.pick(name, this.config$.value);
    };
    /**
     * Get a json setting by key and decode it.
     */
    Settings.prototype.getJson = function (name, defaultValue) {
        if (defaultValue === void 0) { defaultValue = null; }
        var value = this.get(name, defaultValue);
        if (typeof value !== 'string')
            return value;
        return JSON.parse(value);
    };
    /**
     * Get base url for the app.
     */
    Settings.prototype.getBaseUrl = function (forceServerUrl) {
        if (forceServerUrl === void 0) { forceServerUrl = false; }
        // sometimes we might need to get base url supplied by backend
        // even in development environment, for example, to prevent
        // uploaded images from having proxy urls like "localhost:4200"
        if (this.has('base_url') && (this.get('vebto.environment') === 'production' || forceServerUrl)) {
            return this.get('base_url') + '/';
        }
        else if (document.querySelector('base')) {
            return document.querySelector('base')['href'];
        }
        else {
            // 'https://site.com/subdomain/index.html/" => 'https://site.com/subdomain/'
            var url = window.location.href.split('?')[0];
            return url.replace(/([^\/]+\.\w+($|\/$))/, '');
        }
    };
    /**
     * Get app's asset base url.
     */
    Settings.prototype.getAssetUrl = function (suffix) {
        var uri = (this.get('vebto.assetsUrl') || this.getBaseUrl());
        var prefix = this.get('vebto.assetsPrefix');
        // in production assets will be in "client" sub-folder
        if (this.get('vebto.environment') === 'production' && prefix) {
            uri += prefix + '/';
        }
        uri += 'assets/';
        if (suffix)
            uri += suffix;
        return uri;
    };
    /**
     * Save specified setting on the server.
     */
    Settings.prototype.save = function (settings) {
        this.setMultiple(settings.client);
        var jsonSettings = { files: settings.files };
        // need to encode settings as json to preserve
        // booleans as form data will always be a string
        // also need to encode as base64 to make sure requests
        // are not blocked when setting contains <scripts>
        jsonSettings.client = JSON.stringify(settings.client);
        jsonSettings.server = JSON.stringify(settings.server);
        var data = objToFormData(jsonSettings);
        return this.http.post('settings', data);
    };
    /**
     * Check if any social login is enabled.
     */
    Settings.prototype.anySocialLoginEnabled = function () {
        var _this = this;
        var names = ['facebook', 'google', 'twitter'];
        return names.filter(function (name) { return _this.get('social.' + name + '.enable'); }).length > -1;
    };
    /**
     * Set HttpClient instance.
     */
    Settings.prototype.setHttpClient = function (http) {
        this.http = http;
    };
    Settings.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Settings_Factory() { return new Settings(); }, token: Settings, providedIn: "root" });
    return Settings;
}());
export { Settings };
